import NavigationBar from 'app/Homepage/components/NavigationBar'
import Header from 'app/Homepage/components/Header'
import InfoTerkiniListGroup from './InfoTerkiniListGroup'

const InfoTerkini = ({ isRuangGtkEnabled }) => {
  return (
    <div className="mt-14">
      <Header
        isRuangGtkEnabled={isRuangGtkEnabled}
        title={isRuangGtkEnabled ? 'Pemberitahuan' : 'Info Terkini'}
        showUserProfile={false}
      />

      <InfoTerkiniListGroup />

      <NavigationBar isRuangGtkEnabled={isRuangGtkEnabled} />
    </div>
  )
}

export default InfoTerkini
